export default "__VITE_ASSET__g14LElA0__"